"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacityPeriod = void 0;
class CapacityPeriod {
    constructor(team, regionCapacity, percent) {
        this.team = team;
        this.regionCapacity = regionCapacity;
        this.percent = percent;
    }
    getWeekdays() {
        return this.regionCapacity.weekdays;
    }
    getHolidays() {
        return this.regionCapacity.holidays.length;
    }
    getWorkingDays() {
        return this.getWeekdays() - this.getHolidays();
    }
    getCapacityDays() {
        return (this.getWorkingDays() * this.percent) / 100;
    }
    getCapacityHours() {
        return this.getCapacityDays() * 8;
    }
    getCapacityHours1850() {
        return (Math.round(1850 / 12) * this.percent / 100);
    }
}
exports.CapacityPeriod = CapacityPeriod;
//# sourceMappingURL=CapacityPeriod.js.map